import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';

import { isNodeEnvironment } from '../../js/utils-fetch-data-json.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';



export async function fetchCountries(forceRefresh = false) {

    try {
        if (isNodeEnvironment()) {



            return [];

        } else {

            const storageKey = `countries_${appState.SiteLanguageCookie}`;
            const expiryKey = `${storageKey}_expiry`;
            const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

            if (!forceRefresh) {
                const cached = loadFromLocalStorage(storageKey);
                const expiryTime = loadFromLocalStorage(expiryKey);

                if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
                    console.log('✅ Loaded countries from cache');
                    return cached;
                }
            }

            const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CountryStateCityDataService/GetAllCanShipToCountriesUserAsync?languageCode=${appState.SiteLanguageCookie}`;
            const response = await fetch(apiEndPoint);

            if (!response.ok) throw new Error('Failed to fetch countries from the server');

            const finalResult = await response.json();
            saveToLocalStorage(storageKey, finalResult);
            saveToLocalStorage(expiryKey, Date.now() + expiryDuration);

            console.log('🌐 Fetched countries from the server');
            return finalResult;
        }
    } catch (error) {
        console.error('❌ Error fetching countries', error);
        return [];
    }

}


   export async function fetchStates(countryId) {
        try {

            if (isNodeEnvironment()) {



                return [];

            } else {

                if (!countryId || countryId === '0') return [];

                const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CountryStateCityDataService/GetAllCanShipToStatesByCountryUserAsync?countryId=${countryId}&languageCode=${appState.SiteLanguageCookie}`;

                const response = await fetch(apiEndPoint);

                if (!response.ok) throw new Error(`Failed to fetch states for country ID: ${countryId}`);

                const states = await response.json();
                return states;
            }
        } catch (error) {
            console.error('❌ Error fetching states:', error);
            return [];
        }
    }

  export  async function fetchCities(stateId) {
        try {

            if (isNodeEnvironment()) {



                return [];

            } else {

                if (!stateId || stateId === '0') return [];

                const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CountryStateCityDataService/GetAllCanShipToCitiesByStateUserAsync?stateId=${stateId}&languageCode=${appState.SiteLanguageCookie}`;

                const response = await fetch(apiEndPoint);

                if (!response.ok) throw new Error(`Failed to fetch cities for state ID: ${stateId}`);

                const cities = await response.json();
                return cities;
            }
        } catch (error) {
            console.error('❌ Error fetching cities:', error);
            return [];
        }
    }


export async function fetchGetAllActiveCallingCodesAsync(forceRefresh = false) {
    try {
        if (isNodeEnvironment()) {
            return [];
        } else {
            const storageKey = `all_countries_calling-codes_${appState.SiteLanguageCookie}`;
            const expiryKey = `${storageKey}_expiry`;
            const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

            if (!forceRefresh) {
                const cached = loadFromLocalStorage(storageKey);
                const expiryTime = loadFromLocalStorage(expiryKey);

                if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
                    console.log('✅ Loaded countries from cache');
                    return cached;
                }
            }
            const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CountryStateCityDataService/GetAllActiveCallingCodesAsync?languageCode=${appState.SiteLanguageCookie}`;
            const response = await fetch(apiEndPoint);
            if (!response.ok) throw new Error('Failed to fetch calling codes from the server');

            const finalResult = await response.json();
            saveToLocalStorage(storageKey, finalResult);
            saveToLocalStorage(expiryKey, Date.now() + expiryDuration);

            console.log('🌐 Fetched calling codes from the server');
           
            return finalResult;
        }
    } catch (error) {
        console.error('❌ Error fetching calling codes:', error);
        return [];
    }
}


